<template>
    <div>
        <img :class="isShow" @click="scollTop" class="scollTop" src="@/assets/images/top.png" alt="">
    </div>
</template>
<script>
import $ from "jquery";
export default {
    data(){
        return {
            isShow:''
        }
    },
    methods:{
        // 点击平滑过渡
    scollTop(){
      $("html, body").animate({ scrollTop: 0 }, 300);
    },
    },
    mounted() {
    /* 监听滚动 */
    this.$nextTick(() => {
      // 调用，使用this.$nextTick DOM刷新后调用
      // 监听滚动条事件
      $(window).scroll(() => {
        let st = parseInt($(window).scrollTop());
        st>200?this.isShow = 'activedShow': this.isShow= ''
      });
    });
  },
}
</script>
<style scoped>
.activedShow{
  transition: .2s!important;
  transform: translateX(0)!important;
}
.activedHide{
  transition: .2s;
  transform: translateX(200%);
}
.scollTop{
  width: 30px;
  height: 30px;
  position: fixed;
  right: 2%;
  bottom: 80px;
  z-index: 9;
  transition: .2s;
  transform: translateX(150%);
}
</style>